<template>
    <basic-modal
            @hide="close"
            v-model="opened"
            aria-label="Invite User"
            role="dialog">
        <template #header>
            <div>
                <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
                <h3 class="modal-title">Invite User</h3>
            </div>
        </template>
        <div class="row" style="margin-top: 15px;">
            <div class="col-sm-12">
                <label for="optional-role-input">What role does this person play?</label>
                <input type="text"
                       id="optional-role-input"
                       ref="roleInput"
                       class="form-control"
                       v-model="role"
                       placeholder="Teacher, Doctor, Social Worker, Parent">
                <typeahead v-if="opened" v-model="role" target="#optional-role-input" :data="roles"></typeahead>
            </div>
        </div>
        <template #footer>
            <div>
                <div class="row">
                    <div class="col-sm-12">
                        <button class="btn btn-mm btn-green" type="button" @click="invite">Invite</button>
                    </div>
                </div>
            </div>
        </template>
    </basic-modal>
</template>

<script>
    import PopupPromiseMixin from '~/vue/mixins/PopupPromiseMixin';

    const ROLES = ['Teacher', 'Parent', 'Friend', 'Doctor', 'Family', 'Social Worker', 'Other'];

    export default {
        name: "OptionalRoleSetPopup",
        mixins: [PopupPromiseMixin],
        data() {
            return {
                role: '',
                roles: ROLES,
            };
        },
        computed: {
            firstFocusEl() {
                return this.$refs.roleInput;
            }
        },
        methods: {
            resetData() {
                this.role = '';
            },
            invite() {
                this.save(this.role);
            },
        }
    };
</script>
